export const calendarIconWrapperStyles = {
  padding: 0,
  margin: 0,

  '& > button': {
    margin: 0,
  },
};

const calendarPopoverPaperStyles = {
  borderRadius: 1,
  marginTop: 1,
};

export const calendarPopoverSlotProps = {
  paper: { sx: calendarPopoverPaperStyles },
};

export const calendarPopoverAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const calendarPopoverTransformOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const pickerContentRowStyles = {
  display: 'flex',
  alignItems: 'stretch',
};

export const dateCalendarStyles = {
  flexShrink: 0,
};

export const timeClockStyles = {
  borderLeft: '1px solid',
  borderColor: 'divider',
};
